var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMagnifier(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 20,
    viewBox: "0 0 22 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.3697 12.5786H14.446L14.1186 12.2699C15.2645 10.9663 15.9544 9.27387 15.9544 7.43282C15.9544 3.32762 12.5518 0 8.35413 0C4.15647 0 0.753906 3.32762 0.753906 7.43282C0.753906 11.538 4.15647 14.8656 8.35413 14.8656C10.2366 14.8656 11.9672 14.191 13.3001 13.0703L13.6158 13.3905V14.2939L19.4622 20L21.2044 18.2962L15.3697 12.5786ZM8.35413 12.5786C5.44266 12.5786 3.09244 10.2802 3.09244 7.43282C3.09244 4.58548 5.44266 2.28702 8.35413 2.28702C11.2656 2.28702 13.6158 4.58548 13.6158 7.43282C13.6158 10.2802 11.2656 12.5786 8.35413 12.5786Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMagnifier);
export default __webpack_public_path__ + "static/media/magnifier.f8531f38d13bdcf4eed38ede344c5c39.svg";
export { ForwardRef as ReactComponent };